import { PencilRuler, Factory, Truck } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal, Chapter } from "./shared";

const ICONS = [PencilRuler, Factory, Truck];

export const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="scroll-mt-24 bg-white" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-32">
        <Chapter num="03" label={t.services.chapter.split("/ ")[1]} />
        <Reveal>
          <h2 data-testid="services-heading" className="mt-12 font-display text-3xl font-extrabold tracking-tight text-neutral-950 sm:text-4xl lg:text-5xl">
            {t.services.heading}
          </h2>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {t.services.items.map(([title, desc], i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full rounded-[1.5rem] border border-neutral-200 bg-paper p-8 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-2 hover:border-brand-200 hover:shadow-[0_28px_60px_-30px_rgba(44,56,28,0.35)] sm:p-10"
                >
                  <div className="flex items-center justify-between">
                    <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-100 text-brand-700 transition-colors duration-500 group-hover:bg-brand-600 group-hover:text-white">
                      <Icon size={22} />
                    </span>
                    <span className="font-mono text-xs tracking-[0.25em] text-neutral-300 transition-colors duration-500 group-hover:text-brand-600">{`0${i + 1}`}</span>
                  </div>
                  <h3 className="mt-8 font-display text-2xl font-bold text-neutral-900">{title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-neutral-500">{desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
